export const profileScoreFormatterV2 = (profileScore, checkBoxSettings) => {
  const {
    EonScoreIsAuto,
    insuranceScoreIsAuto,
    supplierScoreIsAuto,
  } = checkBoxSettings;

  let formattedObject = {
    EONScore: profileScore.EONScoreAuto,
    insuranceScore: profileScore.insuranceScoreAuto,
    supplierScore: profileScore.supplierScoreAuto,
    bonusScore: profileScore.bonusScoreAuto,
    energyAndConsumptionScore: profileScore.energyAndConsumptionScoreAuto,
    trainingScore: profileScore.trainingScore,
    certifiedScore: profileScore.certifiedScoreAuto,
    profileId: profileScore.profileId,
    type: profileScore.type,
    EonScoreIsAuto: EonScoreIsAuto,
    insuranceScoreIsAuto: insuranceScoreIsAuto,
    supplierScoreIsAuto: supplierScoreIsAuto,
    trainingCourses: profileScore.trainingCourses || [],
    trainingScore: profileScore.trainingScore || 0,
  };

  if (EonScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      EONScore: profileScore.EONScoreManual,
    };
  }

  if (insuranceScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      insuranceScore: profileScore.insuranceScoreManual,
    };
  }

  if (supplierScoreIsAuto === false) {
    formattedObject = {
      ...formattedObject,
      supplierScore: profileScore.supplierScoreManual,
    };
  }

  return formattedObject;
};
